import React from 'react';
import styled from 'styled-components';
import SELL_TRACTOR_USE_CASE_FX850_IMAGE from '../../../../../assets/images/userSellTractor/sell_tractor_use_case_fx850.png';
import SELL_TRACTOR_USE_CASE_A4800_IMAGE from '../../../../../assets/images/userSellTractor/sell_tractor_use_case_a4800.png';
import SELL_TRACTOR_USE_CASE_6150R_IMAGE from '../../../../../assets/images/userSellTractor/sell_tractor_use_case_6150r.png';
import SELL_TRACTOR_USE_CASE_M6135_IMAGE from '../../../../../assets/images/userSellTractor/sell_tractor_use_case_m6135.png';
import SELL_TRACTOR_USE_CASE_YT5113_IMAGE from '../../../../../assets/images/userSellTractor/sell_tractor_use_case_yt5113.png';
import SELL_TRACTOR_USE_CASE_MR707_IMAGE from '../../../../../assets/images/userSellTractor/sell_tractor_use_case_mr707.png';
import SELL_TRACTOR_USE_CASE_MT7115_IMAGE from '../../../../../assets/images/userSellTractor/sell_tractor_use_case_mt7115.png';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const useCaseImages = [
  SELL_TRACTOR_USE_CASE_FX850_IMAGE,
  SELL_TRACTOR_USE_CASE_A4800_IMAGE,
  SELL_TRACTOR_USE_CASE_6150R_IMAGE,
  SELL_TRACTOR_USE_CASE_M6135_IMAGE,
  SELL_TRACTOR_USE_CASE_YT5113_IMAGE,
  SELL_TRACTOR_USE_CASE_MR707_IMAGE,
  SELL_TRACTOR_USE_CASE_MT7115_IMAGE,
];

export const SellTractorUseCase = () => {
  const slideItems = useCaseImages.map((image) => {
    const modelName = image.split('use_case_')[1].split('.')[0].toUpperCase();
    return {
      key: modelName,
      element: <Image alt={modelName} src={image} />,
    };
  });

  return (
    <Container>
      <ContentsContainer>
        <TextContainer>
          <Title>{'이미 많은 분들이\n이용하고 있어요'}</Title>
          <Description>{'가격 제안 받고 직거래 판매 등록까지!'}</Description>
        </TextContainer>
      </ContentsContainer>

      <SwiperWrapper id={'infinite-loop-swiper'}>
        <CustomSwiper
          modules={[Autoplay]}
          slidesPerView={'auto'}
          spaceBetween={16}
          loop
          speed={3000}
          autoplay={{
            delay: 0,
            pauseOnMouseEnter: false,
            disableOnInteraction: false,
          }}
          allowTouchMove={false}
          pagination={{ clickable: false }}
        >
          {slideItems.map((slideItem) => {
            return (
              <CustomSwiperSlide key={slideItem.key} width={174}>
                {slideItem.element}
              </CustomSwiperSlide>
            );
          })}
        </CustomSwiper>
      </SwiperWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  padding: 48px 16px;
`;

const ContentsContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.pre`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/XXX-Large/xxxl-bold */
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 31.2px */
`;

const Description = styled.p`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;

const Image = styled.img`
  width: 100%;
`;

const SwiperWrapper = styled.div`
  width: 100%;
`;

const CustomSwiper = styled(Swiper)`
  width: calc(100% + 32px);
  transform: translateX(-16px);
`;

const CustomSwiperSlide = styled(SwiperSlide)<{ width: number }>`
  width: ${({ width }) => width}px;
`;
